import { render, staticRenderFns } from "./MainNavbarApps.vue?vue&type=template&id=3138925c"
import script from "./MainNavbarApps.vue?vue&type=script&lang=js"
export * from "./MainNavbarApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports